// components
import DisplayValue from "components/BusinessProfileSections/DisplayValue";

// constants
import { BusinessTypeCodes } from "constants/SAMEntity";

// icons
import { CheckIcon } from "components/icons";
import { XIcon } from "components/icons";


// styles
import styles from "./SamEntityPage.module.scss";

export default function BusinessTypes({ businessTypes }: { businessTypes: string[] }) {

	const codes = Object.keys(BusinessTypeCodes);

	return (
		<>
			<h5 className={styles["label"]}>Business Types</h5>
			<ul className={styles['business-types-list-root']}>
				{
					codes.map((code) => {
						return (
							<li key={code}>
								{businessTypes.includes(code) ? (
									<CheckIcon height="24" width="24" color="#00A91C" />
								) : (
									<XIcon height="24" width="24" color="#D54309" />
								)}
								<DisplayValue
									messageElement="code"
									className={styles["value"]}
									value={code}
								/>
								{BusinessTypeCodes[code]}
							</li>
						);
					})
				}
			</ul>
		</>
	);
}
